import {
    Badge,
    Divider,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from "@mui/material";

import PlayLessonRoundedIcon from "@mui/icons-material/PlayLessonRounded";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import AccountBoxRoundedIcon from "@mui/icons-material/AccountBoxRounded";
import SettingsIcon from "@mui/icons-material/Settings";
import ReceiptRoundedIcon from "@mui/icons-material/ReceiptRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import WorkIcon from "@mui/icons-material/Work";
import AssignmentIcon from "@mui/icons-material/Assignment";
import QuizRoundedIcon from "@mui/icons-material/QuizRounded";
import Link from "next/link";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import { useQuery } from "@apollo/client";
import { PROFILE } from "@/graphql/queries/profile";

export default function DrawerItemList({ handleItemClick = () => {} }) {
    const { data: { profile } = {} } = useQuery(PROFILE, {
        fetchPolicy: "cache-first",
    });

    const isProfileFullFilled = profile?.meta?.isFullFilled ?? false;

    return (
        <div>
            <Divider />
            <List>
                <ListItem disablePadding>
                    {/* <ListItemButton onClick={() => router.push(`/dashboard`)}>
                        <ListItemIcon>
                            <GridViewRoundedIcon />
                        </ListItemIcon>
                        <ListItemText primary={"پیشخوان"} />
                    </ListItemButton> */}
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick();
                        }}
                        href={"/courses"}
                        component={Link}
                    >
                        <ListItemIcon>
                            <PlayLessonRoundedIcon />
                        </ListItemIcon>
                        <ListItemText primary={"دوره و جلسات"} />
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick();
                        }}
                        href={"/reports"}
                        component={Link}
                    >
                        <ListItemIcon>
                            <AssignmentTurnedInRoundedIcon />
                        </ListItemIcon>
                        <ListItemText primary={"کارنامه"} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick();
                        }}
                        href={"/assignments"}
                        component={Link}
                    >
                        <ListItemIcon>
                            <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary={"تکالیف"} />
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick();
                        }}
                        href={"/profile"}
                        component={Link}
                    >
                        <ListItemIcon>
                            <AccountBoxRoundedIcon />
                        </ListItemIcon>

                        <ListItemText>
                            پروفایل
                            {!isProfileFullFilled && (
                                <Badge
                                    variant="dot"
                                    max={99}
                                    color="error"
                                    overlap="rectangular"
                                    anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                    }}
                                    sx={{ marginLeft: "10px" }}
                                ></Badge>
                            )}
                        </ListItemText>
                    </ListItemButton>
                </ListItem>


                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick();
                        }}
                        href={"/settings"}
                        component={Link}
                    >
                        <ListItemIcon>
                            <SettingsIcon />
                        </ListItemIcon>

                        <ListItemText>
                            تنظیمات
                        </ListItemText>
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick();
                        }}
                        href={"/questions/mine"}
                        component={Link}
                    >
                        <ListItemIcon>
                            <LiveHelpIcon />
                        </ListItemIcon>
                        <ListItemText primary={"سوال های من"} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick();
                        }}
                        href={"/questions/common"}
                        component={Link}
                    >
                        <ListItemIcon>
                            <QuizRoundedIcon />
                        </ListItemIcon>
                        <ListItemText primary={"پرسش‌ و پاسخ"} />
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick();
                        }}
                        href={"/financial/transactions"}
                        component={Link}
                    >
                        <ListItemIcon>
                            <ReceiptRoundedIcon />
                        </ListItemIcon>
                        <ListItemText primary={"تراکنش‌ها"} />
                    </ListItemButton>
                </ListItem>
            </List>
            <Divider />
            <List>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick();
                        }}
                        href={"/about"}
                        component={Link}
                    >
                        <ListItemIcon>
                            <InfoRoundedIcon />
                        </ListItemIcon>
                        <ListItemText primary={"درباره ما"} />
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick();
                        }}
                        href={"/careers"}
                        component={Link}
                    >
                        <ListItemIcon>
                            <WorkIcon />
                        </ListItemIcon>
                        <ListItemText primary={"همکاری با ما"} />
                    </ListItemButton>
                </ListItem>
            </List>
        </div>
    );
}
